export default __webpack_public_path__ + "static/media/streetlight.56f83042.webp";